export const IDENTITY_NAMESPACE = 'identity';
